<template>
  <div>
    <div v-show="false"> {{getResourcesListCounter}} </div>
    <div v-show="false"> {{getPartsListCounter}} </div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row class="ml-2 mt-4 mb-4 mr-2">
          <div :class="ui.textSubheading">
            Resource Summary
          </div>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor"
          v-if="this.enableAssetRegisterCalc">
            <v-icon left :color="ui.btnColor"> emoji_transportation </v-icon>
              <div :class="ui.textSubheadingBold">
                {{na1}}
            </div>
          </v-chip>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor"
          v-if="!this.enableAssetRegisterCalc">
            <v-icon left :color="ui.colorWarning"> warning </v-icon>
              <div :class="ui.textSubheadingBoldWarning">
                No Asset
            </div>
          </v-chip>
        </v-layout>
        <v-layout row class="ml-0">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> schedule </v-icon>
              <div :class="ui.textSubheadingBold">
                Resource Allocation
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> person </v-icon>
              <div :class="ui.textSubheadingBold">
                Site
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcResourcesListHours("Site", this.getResourcesList, this.na1)}}
              / {{this.calcResourcesListCost("Site", this.getResourcesList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> person_add </v-icon>
              <div :class="ui.textSubheadingBold">
                Contractor
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcResourcesListHours("Contract", this.getResourcesList, this.na1)}}
              / {{this.calcResourcesListCost("Contract", this.getResourcesList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> engineering </v-icon>
              <div :class="ui.textSubheadingBold">
                Vendor
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcResourcesListHours("Vendor", this.getResourcesList, this.na1)}}
              / {{this.calcResourcesListCost("Vendor", this.getResourcesList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcResourcesListHours("ALL", this.getResourcesList, this.na1)}}
              / {{this.calcResourcesListCost("ALL", this.getResourcesList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>

        <v-layout row class="ml-0 mr-3 mt-4">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> apps</v-icon>
              <div :class="ui.textSubheadingBold">
                Parts Estimate
            </div>
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> category </v-icon>
              <div :class="ui.textSubheadingBold">
                Materials
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListQty("Matl", this.getPartsList, this.na1)}}
              / {{this.calcPartsListCost("Matl", this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> widgets </v-icon>
              <div :class="ui.textSubheadingBold">
                Parts
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListQty("Part", this.getPartsList, this.na1)}}
              / {{this.calcPartsListCost("Part", this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> build </v-icon>
              <div :class="ui.textSubheadingBold">
                Tools
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListQty("Tool", this.getPartsList, this.na1)}}
              / {{this.calcPartsListCost("Tool", this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> local_shipping </v-icon>
              <div :class="ui.textSubheadingBold">
                Hire
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListQty("Hire", this.getPartsList, this.na1)}}
              / {{this.calcPartsListCost("Hire", this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListQty("ALL", this.getPartsList, this.na1)}}
              / {{this.calcPartsListCost("ALL", this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row class="ml-0 mt-4">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> functions </v-icon>
              <div :class="ui.textSubheadingBold">
                Total Resource Estimate
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> attach_money </v-icon>
              <div :class="ui.textSubheadingBold">
                Cost
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcTotalEstimateCost(this.getResourcesList, this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-4 mr-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> co2 </v-icon>
              <div :class="ui.textSubheadingBold">
                Carbon
            </div>
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheadingBold">
              {{this.calcPartsListCarbon(this.getPartsList, this.na1)}}
            </div>
          </v-chip>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [financeFunctions, apptheme],
  // components: {
  //   RoleDevelopmentManageCard,
  //   RoleDevelopmentSummaryCard
  // },
  computed: {
    ...mapGetters([
      "getResourcesList",
      "getAssetRegister",
      "getPartsList",
      "getDetailRelps",
      "getResourcesListCounter",
      "getPartsListCounter"
    ]),
    enableAssetRegisterCalc() {
      let logic = null;
      if (
        this.getAssetRegister !== null &&
        this.getAssetRegister !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    na1() {
      let n = null;
      if (this.enableAssetRegisterCalc) {
        n = this.getAssetRegister.length;
      } else {
        n = 1;
      }
      return n;
    }
  }
};
</script>
